<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractSubcontractToForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <!-- eslint-disable -->
        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isSubcontrInadmissible') && avContract.hasPrincipalAcceptedSubcontr != 1 && avContract.isSubcontrOutsourcingValid != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isSubcontrInadmissible"
              label="Eine Unterbeauftragung ist unzulässig."
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.hasPrincipalAcceptedSubcontr') && avContract.isSubcontrInadmissible != 1 && avContract.isSubcontrOutsourcingValid != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasPrincipalAcceptedSubcontr"
              label="Der Auftraggeber stimmt der Beauftragung der nachfolgenden Unterauftragnehmer zu unter der Bedingung einer vertraglichen Vereinbarung nach Maßgabe des Art. 28 Abs. 2-4 DS-GVO"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.subcontractors') && avContract.hasPrincipalAcceptedSubcontr == 1" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.subcontractors"
              label="Unterauftragnehmer"
              class="caption"
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isSubcontrOutsourcingValid') && avContract.isSubcontrInadmissible != 1 && avContract.hasPrincipalAcceptedSubcontr != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isSubcontrOutsourcingValid"
              label="Die Auslagerung auf Unterauftragnehmer oder der Wechsel des bestehenden Unterauftragnehmers sind zulässig"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isSubcontractorNotAllowed') && avContract.isSubcontrInadmissible != 1 && avContract.isMainPrincipalToAsk != 1 && avContract.isMainContractorToAsk != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isSubcontractorNotAllowed"
              label="Eine weitere Auslagerung durch den Unterauftragnehmer ist nicht gestattet"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isMainPrincipalToAsk') && avContract.isSubcontrInadmissible != 1 && avContract.isSubcontractorNotAllowed != 1 && avContract.isMainContractorToAsk != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isMainPrincipalToAsk"
              label="Eine weitere Auslagerung durch den Unterauftragnehmer bedarf der ausdrücklichen Zustimmung des Hauptauftraggebers (mind. Textform)"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isMainContractorToAsk') && avContract.isSubcontrInadmissible != 1 && avContract.isSubcontractorNotAllowed != 1 && avContract.isMainPrincipalToAsk != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isMainContractorToAsk"
              label="Eine weitere Auslagerung durch den Unterauftragnehmer bedarf der ausdrücklichen Zustimmung des Hauptauftragnehmers (mind. Textform)"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>
        <!-- eslint-enable -->
      </v-flex>
    </v-layout>
  </div>
</template>
